import { render } from "./CxSpinner.vue?vue&type=template&id=02af5098&ts=true"
import script from "./CxSpinner.vue?vue&type=script&lang=ts"
export * from "./CxSpinner.vue?vue&type=script&lang=ts"

import "./CxSpinner.vue?vue&type=style&index=0&id=02af5098&lang=less"

import exportComponent from "C:\\hexagon_develop\\hexagon_develop\\conx-ui\\microfrontends\\conx-ui-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__